import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  stylesPropType,
  componentsPropType,
  vmPropTypes
} from '../../../global-prop-types';
import ComponentsArrRenderer from '../../core/ComponentsArrRenderer';
import moduleStyles from './styles.module.css';
import useTheme from '../../../global-hooks/useTheme';
import GridItem from './GridItem';

const GridContainer = (props) => {
  const {
    styles,
    variant,
    alwaysFullWidth = true,
    maxWidth,
    startTimeGridContainer,
    endTimeGridContainer,
    ...restProps
  } = props;

  const theme = useTheme();
  const isDateValid = (dateStr) => dateStr instanceof Date && !isNaN(dateStr);
  const unlockContent = useSelector((state) => state?.appState?.unlockContent);

  const showByDateTime = () => {
    if (unlockContent) return true; // bypass all time restrictions
    const now = Date.now();

    if (isDateValid(startTimeGridContainer) && isDateValid(endTimeGridContainer)) {
      if (now >= startTimeGridContainer && now <= endTimeGridContainer) {
        return true;
      }

      return false;
    }

    return true;
  };
  const maxWidthAllowed = () => {
    if (alwaysFullWidth) {
      return '100%';
    }
    if (maxWidth) {
      return maxWidth;
    }
    const maxBreakpoint = theme.breakpoints.values.xxl
      || theme.breakpoints.values.xl
      || theme.breakpoints.values.lg;
    if (maxBreakpoint) {
      return maxBreakpoint;
    }
    return 1440;
  };

  return (
    showByDateTime() && (
    <div
      className={`${moduleStyles.gridContainerWrapper} GridContainer-wrapper`}
      style={{ ...styles?.wrapper }}
    >
      <div
        className={`${moduleStyles.gridContainer} GridContainer ${
          variant || ''
        }`}
        style={{
          maxWidth: maxWidthAllowed(),
          gap: 'var(--link-box-grid-gap)',
          ...styles?.container
        }}
      >
        <ComponentsArrRenderer {...restProps} />
      </div>
    </div>
    )
  );
};

GridContainer.propTypes = {
  styles: stylesPropType,
  alwaysFullWidth: PropTypes.bool,
  maxWidth: PropTypes.number,
  variant: PropTypes.string,
  startTimeGridContainer: PropTypes.object,
  endTimeGridContainer: PropTypes.object,
  components: componentsPropType
};

GridContainer.defaultProps = {
  variant: '',
  styles: {
    wrapper: {},
    container: {}
  },
  alwaysFullWidth: false,
  startTimeGridContainer: '',
  endTimeGridContainer: '',
  components: []
};

GridContainer.vmPropTypes = {
  styles: { wrapper: vmPropTypes.styles, container: vmPropTypes.styles },
  alwaysFullWidth: vmPropTypes.boolean,
  maxWidth: vmPropTypes.number,
  variant: vmPropTypes.className,
  startTimeGridContainer: vmPropTypes.timestamp,
  endTimeGridContainer: vmPropTypes.timestamp,
  components: vmPropTypes.components
};

GridContainer.vmPreview = {
  components: [
    {
      componentName: 'GridItem',
      ...GridItem.defaultProps
    }
  ]
};

GridContainer.processPropVmTypes = (props) => {
  const { styles, variant, ...restProps } = props;

  return ComponentsArrRenderer.processPropVmTypes(restProps);
};

export default GridContainer;
